module.exports = __webpack_public_path__ + "static/media/img_Inscription_free1@3x.bf2f8cab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Inscription_free1@3x.png
// module id = 983
// module chunks = 0